import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { Partner } from "../domain/partner";
import { Localisation } from "../model/localisation.model";
import { CoreData } from "../tools/core-data/core-data";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base-service";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({
    providedIn: 'root',
})
export class AddressService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/address`;

    constructor(public http: HttpClient,
        protected coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected router: Router) {
        super(router, coreData, snackBare);
    }

    getMatchingAddressList(text: string) {
        let params = new HttpParams();
        if (text) {
            params = params.append('filter', `${text}`);
        }
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}`, this.generateHeaderWithParameters(params)).pipe(
            catchError(this.handleError<any>('getMatchingAddressList')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: Localisation[]) => {
                // response.features.map(x => x.properties)
                return (response as any).features.map(x => x.properties).map((item: Localisation) => {
                    return Localisation.mapFromJSON(item);
                });
            }));
    }

    getPartners(zipCode: string) {

        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${zipCode}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getPartners')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: Partner[]) => {
                return response.map((item: Partner) => {
                    return Partner.mapFromJSON(item);
                });
            }));
    }
}